<script setup>
import { getDeclOfNum, localeDate, getPercentage } from '@/utils';
import { ref, computed, onMounted } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useApi } from '@/composables/useApi';
import 'swiper/css';

const { getReviews } = useApi();

const swiperOptions = ref({
	slidesPerView: 1,
	spaceBetween: 20,
	orientation: 'horizontal',
});

const props = defineProps({
	item: Object,
});

const reviewsArray = ref([]);

const itemImgSrc = item => {
	return item.img ? `/mediafiles/${item.img}` : '/staticfiles/vue/public/profile.png';
};

const ratingProgress = computed(() => (props.item.average_rating / 5) * 100);

const reviewsText = computed(() =>
	getDeclOfNum(props.item.reviews_count, ['отзыв', 'отзыва', 'отзывов'])
);

const getMasterReviews = async () => {
	reviewsArray.value = await getReviews(props.item.id);
	console.log(reviewsArray.value);
}

onMounted(async () => {
	await getMasterReviews();
})
</script>

<template>
	<div class="master-wr">
		<div class="master-wr__header">
			<img alt="" loading="lazy" :src="itemImgSrc(item)" />
			<h3>{{ item.fullname }}</h3>
			<div class="master-wr__reviews">
				<span>{{ item.average_rating }}</span>
				<div
					class="master-wr__stars"
					:aria-label="`Рейтинг: ${item.average_rating} из 5`"
				>
					<span
						class="master-wr__progress-bar"
						:style="{width: ratingProgress + '%'}"
					/>
				</div>
				<span>{{ reviewsText }}</span>
			</div>
		</div>
		<span class="master-wr__separator" v-if="reviewsArray.length" />
		<Swiper
			class="master-wr__reviews-swiper"
			v-bind="swiperOptions"
			v-if="reviewsArray.length"
		>
			<SwiperSlide
				class="review"
				v-for="slide in reviewsArray"
			>
				<h2>{{ slide.fullname }}</h2>
				<div class="review__rating">
					<div
						class="master-wr__stars"
						:aria-label="`Рейтинг: ${slide.rating} из 5`"
					>
						<span
							class="master-wr__progress-bar"
							:style="{width: getPercentage(slide.rating, 5) + '%'}"
						/>
					</div>
					<span class="review__date">{{ localeDate(slide.created_at) }}</span>
				</div>
				<p class="review__content">{{ slide.text }}</p>
			</SwiperSlide>
		</Swiper>
	</div>
</template>

<style lang="scss">
.master-wr__header {
	display: grid;
	grid-template-rows: 24px 20px 20px;
	grid-template-columns: 64px auto;
	column-gap: 14px;

	img {
		width: 100%;
		height: 100%;
		border-radius: 8px;
		grid-row: 1 / 4;
	}

	h3 {
		font-size: 16px;
		font-family: 'Raleway';
		font-weight: 600;
	}
}

.master-wr__separator {
	width: 110%;
	height: 1px;
	display: block;
	background-color: #d9d9d9;
	margin-block: 12px;
}

.master-wr__reviews-swiper {
	.master-wr__stars { margin-right: 8px }

	h2 {
		font-size: 16px;
		font-family: 'Raleway';
		font-weight: 600;
	}
}

.review__date,
.review__content { font-size: 12px }

.review__content { margin-top: 10px }
</style>
